import { Component, OnInit ,HostListener, ViewChild, AfterViewInit, ChangeDetectorRef, AfterContentChecked} from '@angular/core';

import { ConfirmationService, FilterMetadata, SortEvent } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { AuthenticationService, User } from '../core/services/authentication.service';

import { UserroleService } from '../utility/userrole.service';
import { DelegationBean } from './model/DelegationBean';
import { DelegationBeanDelegates } from './model/DelegationBeanDelegates';
import { UserBean } from './model/UserBean';
import { DelegationService } from './services/delegation-service';
import { EditDelegationComponent } from './edit-delegation/edit-delegation.component';
import { Table } from 'primeng/table';
import { ServiceType } from '../shared/Enums';
import { NgbPagination } from '@ng-bootstrap/ng-bootstrap';
import { SessionStorageService } from '../administration/services/session-storage.service';

@Component({
  selector: 'app-delegation',
  templateUrl: './delegation.component.html',
  styleUrls: ['./delegation.component.css'],
})
export class DelegationComponent implements OnInit , AfterViewInit, AfterContentChecked{
  @ViewChild('editDelComponent') editDelegationComponent: EditDelegationComponent;
  @ViewChild('dt') dt!: Table;
  @ViewChild('paginationDelegation') paginationDelegation!: NgbPagination;

  userflag: boolean;
  delegation: DelegationBeanDelegates[] = [];
  allDelegation: DelegationBeanDelegates[] = [];
  allDelegationStable: DelegationBeanDelegates[] = [];
  listOfDelegates: UserBean[];
  showEdit: boolean;
  delegation1: DelegationBean;
  originalResponse: DelegationBean[];
 // isAdmin: boolean ;
  isSupportAdmin: boolean;
  //isSuperAdmin: boolean ;
  canEdit: boolean;
  tableName: string = 'delegationTable';
  sortField: string;
  sortOrder: number;
  constructor(
    private delegationService: DelegationService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private userRoleservice: UserroleService,
    private authenticationService: AuthenticationService,
    private cdr: ChangeDetectorRef,
    private sessionStorageService: SessionStorageService

  ) {  }
  flagAddDef: boolean = false;
  flagEditDef: boolean = false;

  flag: boolean = true;
  viewHistorydist: boolean = false;
  addmode: boolean = false;
  editmode: boolean = false;

  currentPage : number = 1;
  rowsPerPage : number = 15;
  totalRecords: number;
  
  currentSort: SortEvent;
  dataInitialized: boolean = false;

  ngOnInit(): void {
    this.canEdit = this.authenticationService.canUserEdit();
    this.isSupportAdmin = (this.authenticationService.getAppRole() == "supporter");
    this.sortField = 'user.name';
    this.sortOrder = 1;
    if (sessionStorage.getItem(this.tableName)) {
      let tableStorage = JSON.parse(sessionStorage.getItem(this.tableName)+"");
      this.sortField = tableStorage.sortField
        ? tableStorage.sortField
        : this.sortField;
      this.sortOrder = tableStorage.sortOrder
        ? tableStorage.sortOrder
        : this.sortOrder;
    }
    this.delegationService.getDelegations().then((res: DelegationBean[]) => {
      if (res) {
        this.originalResponse = res;
        this.showEdit = false;

        this.delegation = res.map((v) => ({
          user: v.user,
          organisationDisplayName: v.user.name + "(CVR " + v.user.cvr + ")",
          delegeredeUser: this.getDelegates(v.delegeredeUser),
          routingInfRef: v.routingInfRef,
          uuid: v.uuid,
          canEdit: v.canEdit
        }));

        this.allDelegation = this.delegation;
        this.allDelegationStable = this.delegation;
        this.totalRecords = this.delegation.length;

        if (this.showPagination) {
          const firstItemIndex = (this.currentPage - 1) * this.rowsPerPage;
          this.delegation = this.allDelegation.slice(firstItemIndex, firstItemIndex + this.rowsPerPage);
        }
        else {
          this.delegation = this.allDelegation;
        }
        this.dataInitialized = true;
        this.cdr.detectChanges();
      }
    })
  }

  ngAfterViewInit(): void {
    const savedStateString = sessionStorage.getItem(this.tableName);
    if (savedStateString) {
      const savedState = JSON.parse(savedStateString);
      if (savedState && savedState.first !== undefined && savedState.rows !== undefined) {
        this.dt.first = savedState.first;
        this.dt.rows = savedState.rows;
      }
    }
    this.inputChange("","");
  }

  ngAfterContentChecked(): void {
    if (this.dataInitialized && this.dt?.value) {
      this.dataInitialized = false;
      this.inputChange("", "");
      this.initPagination();
    }
  }


  @HostListener("window:beforeunload")
  canDeactivate(): Promise<boolean> {
     return new Promise<boolean>((resolve) => {
      let formDelegeredeUserData: UserBean[] = [];

      if (this.editDelegationComponent &&
          this.editDelegationComponent.editDelFormComponent &&
          this.editDelegationComponent.editDelFormComponent.delegation1 &&
          this.editDelegationComponent.editDelFormComponent.delegation1.delegeredeUser) {

          formDelegeredeUserData = this.editDelegationComponent.editDelFormComponent.delegation1.delegeredeUser;
      }

      if (!!this.delegation1?.delegeredeUser && !this.compareDelegeredeUserArray(this.delegation1.delegeredeUser, formDelegeredeUserData)) {

         this.confirmationService.confirm({
           message:
             'Du er ved at navigere væk fra en side med ændrede data uden at gemme først. Ønsker du at fortsætte?',
           header: 'Ændringer er ikke gemt',
           rejectLabel: 'Nej',
           acceptLabel: 'Ja',
           accept: () => {
             this.delegation1 = this.delegation1 ;
             resolve(true);
           },
           reject: () => {
             resolve(false);
           },
         });
       }
       else {
         resolve(true);
       }
     });

   }


  onRowSelect(event: any) {
    if (event.data.canEdit || this.isSupportAdmin) {
      this.delegationService.getDelegationByUUID(event.data.routingInfRef.uuid, event.data.user.cvr).then((del: DelegationBean) => {
        if (del) {
          this.delegation1 = del;
        } else {
          this.originalResponse.filter((x) => {
            if (x.uuid === event.data.uuid) {
              x.delegeredeUser = [];
              this.delegation1 = x;
            }
          })
        }
      })
      this.showEdit = true;
    }
  }

  cancelEdit() {
    this.ngOnInit();
  }
  getDelegates(deleg: UserBean[])
  {
    if(Array.isArray(deleg) && deleg.length) {
      let delegNames = deleg.map((v) => {
        if (v != null) {
          return v.name + " (CVR:"+v.cvr+")";
        } else {
          return "";
        }
      });
      return delegNames.join(',');
    }
    return '';
  }


// Function to compare two arrays of UserBean objects
private compareDelegeredeUserArray(arr1: UserBean[], arr2: UserBean[]): boolean {
  // Check if lengths are different
  if (arr1.length !== arr2.length) {
    return false;
  }

  // Sort both arrays based on uuid
  arr1.sort((a, b) => (a.uuid > b.uuid ? 1 : -1));
  arr2.sort((a, b) => (a.uuid > b.uuid ? 1 : -1));

  // Check if each element in the arrays are equal
  for (let i = 0; i < arr1.length; i++) {
    const obj1 = arr1[i];
    const obj2 = arr2[i];

    // Compare all properties
    if (
      obj1.uuid !== obj2.uuid ||
      obj1.cvr !== obj2.cvr ||
      obj1.name !== obj2.name ||
      obj1.description !== obj2.description ||
      obj1.municipalityCode !== obj2.municipalityCode ||
      obj1.role !== obj2.role ||
      obj1.type !== obj2.type
    ) {
      return false;
    }
  }

  // If all checks pass, arrays are equal
  return true;
}

  getServiceTypeText(serviceType: string): string {
    switch (serviceType) {
      case 'FILSERVICE':
        return ServiceType.FILSERVICE;
      case 'WEBSERVICE':
        return ServiceType.WEBSERVICE;
      default:
        return '';
    }
  }

  onPageChange(pageNumber: number) {
    this.savePagination(pageNumber);
    this.currentPage = pageNumber;
    this.delegation = this.allDelegation.slice((pageNumber - 1) * this.rowsPerPage,
      (pageNumber - 1) * this.rowsPerPage + this.rowsPerPage);
  }

  get showPagination(): any {
    return this.rowsPerPage && (this.rowsPerPage > 0) && (this.allDelegation?.length > this.rowsPerPage);
  }

  customSort(event: SortEvent) {
    if (!this.currentSort) {
      this.currentSort = event;
    }

    let property = event.field as keyof DelegationBeanDelegates;
    let property1, property2: keyof DelegationBeanDelegates;

    if (property) {

      this.allDelegation.sort((data1: any, data2: any) => {
        let value1, value2;
        if (property.includes(".")) {

          property1 = property.split(".").at(0)!;
          property2 = property.split(".").at(1)! as keyof DelegationBeanDelegates;
          value1 = data1[property1][property2];
          value2 = data2[property1][property2];
        } else {
          value1 = data1[property];
          value2 = data2[property];
        }

        let result = null;
        let newOrder = event.order ? event.order : 0;
        result = value1?.toString().localeCompare(value2?.toString());

        return (newOrder * result);
      })
    }

    if(this.allDelegation?.length < this.rowsPerPage) {
      this.delegation = this.allDelegation.slice(0, this.rowsPerPage);
    }
    
    if (this.currentSort.field !== event.field || this.currentSort.order !== event.order) {
      this.paginationDelegation?.pageChange?.emit(1);
      if(this.paginationDelegation) {
        this.paginationDelegation.page = 1;
      }
      this.currentSort = event;
    }

    if(this.paginationDelegation) {
      this.paginationDelegation.page = 1;
    }
  }

  inputChange(inputValue: string, field: string) {
    if (this.allDelegation) {
      if (Object.keys(this.dt.filters).length == 0) {
        this.dt.filters = {
          field: {
            value: inputValue,
            matchMode: "contains"
          }
        };
      }
      let filters = Object.entries(this.dt.filters).map((e) => ({ [e[0]]: e[1] }));
      if (field) {
        for (const filter of filters) {
          if (filter[field] != null) {
            this.dt.filters[field] = {
              value: inputValue,
              matchMode: "contains"
            }
          } else {
            this.dt.filters[field] = {
              value: inputValue,
              matchMode: "contains"
            }
          }
        }
      }

      filters = Object.entries(this.dt.filters).map((e) => ({ [e[0]]: e[1] }));

      this.allDelegation = this.allDelegationStable;
      for (const f of filters) {
        let property = Object.keys(f).at(0) as keyof DelegationBeanDelegates;
        let filterMetadata = f[property] as FilterMetadata;
        if (filterMetadata.value) {
          if (property.includes(".")) {
            this.allDelegation = this.allDelegation.filter(data => this.getValueFromProperty(data, property)?.toString().toLowerCase().includes(filterMetadata.value.toLowerCase()));

          } else {
            this.allDelegation = this.allDelegation.filter(data => data[property]?.toString().toLowerCase().includes(filterMetadata.value.toLowerCase()));
          }
        }
      }
      this.totalRecords = this.allDelegation.length;
      if (this.allDelegation?.length > 0) {
        this.currentPage = 1;
        this.paginationDelegation?.pageChange?.emit(1);
        if(!this.paginationDelegation) {
          this.onPageChange(1);
        } else {
          this.paginationDelegation.page = 1;
        }

        if (this.paginationDelegation) {
          this.paginationDelegation.page = 1;
        }
      }

    }
  }

  getValueFromProperty(obj: any, property: string): any {
    // Split into an array of keys
    const keys = property.split('.');

    // Iterate through the keys to access the nested value
    let current: any = obj;
    for (const key of keys) {
      if (current[key] !== undefined) {
        current = current[key];
      } else {
        // If the key doesn't exist in the current object, return undefined
        return undefined;
      }
    }

    return current;
  }

  private savePagination(page: number) {
    this.sessionStorageService.put(this.sessionStorageService.DELEGATION_PAGINATION, page);
  }

  private initPagination() {
    let page = this.sessionStorageService.get(this.sessionStorageService.DELEGATION_PAGINATION);
    if (this.paginationDelegation?.pageCount < page) {
      this.paginationDelegation?.pageChange?.emit(this.paginationDelegation.pageCount);
      if (this.paginationDelegation) {
        this.paginationDelegation.page = this.paginationDelegation.pageCount;
      }
    } else {
      this.paginationDelegation?.pageChange?.emit(page);
      if (this.paginationDelegation) {
        this.paginationDelegation.page = page;
      }
    }
  }


}
